import { useState, useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { useApi } from './useApi';

export const useUser = () => {
  const { isSignedIn, isLoaded } = useAuth();
  const api = useApi();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      if (!isLoaded) return;
      
      if (!isSignedIn) {
        setUser(null);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await api({ method: 'get', url: '/users/me' });
        setUser(response.data);
        setError(null);
      } catch (err) {
        setError(err.message);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [isSignedIn, isLoaded, api]);

  return { user, loading, error };
}; 